<template>
  <div>
    <h1 class="title">{{$t('general.your-orders')}}</h1>
    <div class="columns is-multiline">
      <div v-for="order in orders.results" :key="order.id" class="column is-12">
        <router-link
          class="box"
          :to="{
            name: 'order-detail',
            params: {id: order.id, key: order.token},
          }"
        >
          <div class="columns is-gapless">
            <div class="column">
              <h2 class="subtitle is-marginless" v-if="order.vanityOrderNumber">
                {{$t('general.order-number')}}: <strong>{{ order.vanityOrderNumber }}</strong>
              </h2>
            </div>
            <div class="column has-text-right-tablet" >
              {{$t('general.from-date')}} <strong>{{ new Date(order.orderDate) | dateFormat('DD.MM.YYYY') }}</strong>
            </div>
          </div>

          <div v-if="order.paymentType && order.paymentType.status != 40 && order.status < 30" class="notification is-info">
            {{$t('notices.voucher-available-after-payment')}}
          </div>

          <div v-for="item in order.orderItems" :key="item.id">
            <OrderArticle :item="item" />
          </div>
          <Separator />

          <b-taglist>
            <b-tag  v-for="prepaid in order.summary.prepaid" :key="prepaid.id" type="is-info">Guthaben genutzt: {{ prepaid.name }} {{ prepaid.amount | amount }}</b-tag>
            <b-tag type="is-dark"> {{ order.paymentType.paymentTypeName }}</b-tag>
            <b-tag type="is-success" v-if="order.paymentType && order.paymentType.status == 40">{{$t('general.payed')}}</b-tag>
          </b-taglist>
        </router-link>
      </div>
    </div>
    <b-pagination :total="orders.total" :current="orders.page" :per-page="25"> </b-pagination>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import OrderArticle from '@/components/OrderArticle'
import Separator from '@/components/Separator'

export default {
  name: 'UserOrders',
  components: {
    OrderArticle,
    Separator,
  },
  computed: {
    ...mapGetters({
      orders: '$_account/orders',
    }),
  },
  async mounted() {
    await this.$store.dispatch('$_account/getOrders', {page: this.orders.page})
  },
}
</script>

<style scoped lang="scss"></style>
